import car1 from '../assets/duster.webp';
import car2 from '../assets/e-vitara.webp';
import car3 from '../assets/urbancruiserev.webp';
import car4 from '../assets/sierraev.webp';
import car5 from '../assets/kodiaq.webp';
import car6 from '../assets/majestor.webp';
import car7 from '../assets/kushaq.webp';
import car8 from '../assets/punchfacelift.webp';
import car9 from '../assets/hector.webp';
import car10 from '../assets/eqs.webp';
import car11 from '../assets/xev9e.webp';
import car12 from '../assets/tharroxx.webp';
import car13 from '../assets/windsor.webp';
import car14 from '../assets/harrierev.webp';
import car15 from '../assets/grandvitara.webp';
// ... import your other assets here
export const expectedCars = [
  { name: 'Renault Duster 2026', price: '10 - 15 Lakh', status: 'EXPECTED: JAN 26, 2026', image: car1, isElectric: false },
  { name: 'Maruti Suzuki e Vitara', price: '20 - 25 Lakh', status: 'EXPECTED: JAN 20, 2026 (LAUNCH)', image: car2, isElectric: true },
  { name: 'Toyota Urban Cruiser EV', price: 'TBD', status: 'EXPECTED: JAN 20, 2026 (LAUNCH)', image: car3, isElectric: true },
  { name: 'Tata Sierra EV', price: '18 - 22 Lakh', status: 'EXPECTED: MAR 2026', image: car4, isElectric: true },
  { name: 'Skoda Kodiaq RS', price: '50 - 55 Lakh+', status: 'EXPECTED: JUN 2026', image: car5, isElectric: false },
  { name: 'MG Majestor (SUV)', price: '40 - 46 Lakh (est.)', status: 'EXPECTED: FEB 12, 2026', image: car6, isElectric: false },
];

export const newlyLaunchedCars = [
  { 
    name: 'Toyota Urban Cruiser Ebella EV', 
    price: '18.00 - 25.00 Lakh (Est.)', 
    status: 'UNVEILED: JAN 20, 2026', 
    image: car3, 
    isElectric: true 
  },
  { 
    name: 'Skoda Kushaq 2026 (Facelift)', 
    price: '10.89 - 19.40 Lakh', 
    status: 'LAUNCHED: JAN 20, 2026', 
    image: car7, 
    isElectric: false 
  },
  { 
    name: 'Tata Punch 2026 (Facelift)', 
    price: '6.12 - 10.54 Lakh', 
    status: 'LAUNCHED: JAN 13, 2026', 
    image: car8, 
    isElectric: false 
  },
  { 
    name: 'MG Hector (Blackstorm Edition)', 
    price: '21.24 - 23.15 Lakh', 
    status: 'LAUNCHED: JAN 20, 2026', 
    image: car9, 
    isElectric: false 
  },
  { 
    name: 'Mercedes-Benz EQS SUV (Celebration Ed.)', 
    price: '1.34 - 1.48 Cr', 
    status: 'LAUNCHED: JAN 14, 2026', 
    image: car10, 
    isElectric: true 
  },
  { 
    name: 'Mahindra XEV 9e', 
    price: '21.90 - 31.25 Lakh', 
    status: 'DELIVERIES: MAR 2026', 
    image: car11, 
    isElectric: true 
  }
];
export const popularCars = [
  { name: 'Mahindra Thar Roxx', price: '12.99 Lakh', status: 'TRENDING', image: car12 },
  { name: 'MG Windsor EV', price: '≈ 13.50 Lakh', status: 'BEST SELLER', image: car13, isElectric: true },
  { name: 'Tata Punch.ev', price: '≈ 10.99 Lakh', status: 'POPULAR', image: car8, isElectric: true },
  { name: 'Tata Harrier EV', price: '≈ 21.49 Lakh', status: 'TRENDING EV', image: car14, isElectric: true },
  { name: 'Maruti Grand Vitara', price: '≈ 10.99 Lakh', status: 'BEST SELLER', image: car15 }
];
